import { ModeBarDefaultButtons } from "plotly.js-dist-min";


export const PLOTLY_DEFAULT_OPTIONS =     {
    displaylogo: false,
    displayModeBar: false,
    modeBarButtonsToRemove: [
        'hoverCompareCartesian',
        'hoverClosestCartesian',
        'lasso2d',
        'select2d',
        'toggleSpikelines',
        'resetViews',
        'sendDataToCloud',
        'zoom2d',
        'pan2d',
        'zoomIn2d',
        'zoomOut2d',
        'autoScale2d',
        'resetScale2d'
    ] as ModeBarDefaultButtons[]
};

